import * as React from "react";
import { DefaultButton, type IContextualMenuProps } from "@fluentui/react";
import { action, makeObservable, observable } from "mobx";
import { observer } from "mobx-react";
import { type UUID } from "../../utils/uuid";
import { ElofleetDialog } from "../atoms/elofleet-dialog";
import { FormCreatePreOpsChecklist } from "../molecules/form-create-pre-ops-checklist";
import { FormUpdateSettingPreOps } from "../molecules/form-update-setting-pre-ops";
import { store } from "../../store";

export interface ListPreOpsChecklistButtonsProps {
    readonly listStateId?: UUID;
}

/**
 * The Checklist page has some special extra list.
 * - Pre-ops Checklist
 * - Pre-ops Checklist Settings
 *
 * This is implemented via a button for pre-ops checklist with a drop-down.
 */

@observer
export class ListPreOpsChecklistButtons extends React.Component<ListPreOpsChecklistButtonsProps> {
    @observable private accessor settingPreOpsDialogVisible = false;
    @observable private accessor createPreOpsDialogVisible = false;

    constructor(props: ListPreOpsChecklistButtonsProps) {
        super(props);
        makeObservable(this);
    }

    @action.bound private closeSettingPreOpsDialog(): void {
        this.settingPreOpsDialogVisible = false;
    }

    @action.bound private openCreatePreOpsDialog(): void {
        this.createPreOpsDialogVisible = true;
    }

    @action.bound private openSettingPreOpsDialog(): void {
        this.settingPreOpsDialogVisible = true;
    }

    @action.bound private closeCreatePreOpsDialogDismiss(): void {
        this.createPreOpsDialogVisible = false;
    }

    public render(): JSX.Element {
        const menuPreOpsProps: IContextualMenuProps = {
            items: [
                {
                    key: "preOps",
                    text: store.i18n.t("listPreOpsChecklist.button.settings"),
                    iconProps: { iconName: "settings" },
                    onClick: this.openSettingPreOpsDialog,
                },
            ],
        };

        return (
            <>
                <DefaultButton
                    text={store.i18n.t("listPreOpsChecklist.button.add")}
                    split
                    primary
                    aria-roledescription="split button"
                    menuProps={menuPreOpsProps}
                    onClick={this.openCreatePreOpsDialog}
                />

                <ElofleetDialog
                    isOpen={this.createPreOpsDialogVisible}
                    title={store.i18n.t("formCreatePreOpsChecklist.title")}
                >
                    {
                        <FormCreatePreOpsChecklist
                            asDialogContent
                            onCreate={this.closeCreatePreOpsDialogDismiss}
                            onDialogCancel={this.closeCreatePreOpsDialogDismiss}
                        />
                    }
                </ElofleetDialog>
                <ElofleetDialog
                    isOpen={this.settingPreOpsDialogVisible}
                    title={store.i18n.t("formUpdateSettingPreOps.dialog.title")}
                >
                    {
                        <FormUpdateSettingPreOps
                            asDialogContent
                            onUpdate={this.closeSettingPreOpsDialog}
                            onDialogCancel={this.closeSettingPreOpsDialog}
                        />
                    }
                </ElofleetDialog>
            </>
        );
    }
}
